import caisseEpargneLogo from 'assets/caisse-epargne-logo.png'

// Design des pages de connexion (espace client + reporting), piloté par variables d'environnement.
//   REACT_APP_LOGIN_DESIGN=new|legacy             (défaut : legacy) — espace client (/sign-in)
//   REACT_APP_LOGIN_BRAND=owen|caisse-epargne     (défaut : owen) — couleurs + logo du nouveau design
//   REACT_APP_LOGIN_PRIMARY_COLOR=#xxxxxx         (optionnel) — surcharge la couleur principale du brand
//   REACT_APP_LOGIN_LOGO_URL=https://...          (optionnel) — surcharge le logo du brand
//   REACT_APP_LOGIN_IMAGE_URL=https://...         (optionnel) — image du panneau de droite (sinon dégradé du brand)
const BRANDS = {
  owen: { title: '#00003a', primary: '#1414ff', dark: '#00003a', mid: '#0000c9', soft: '#4343ff', name: 'Owen' },
  'caisse-epargne': { title: '#2b2b36', primary: '#ED1B2F', dark: '#a50f1d', mid: '#c8132a', soft: '#f4606c', name: "Caisse d'Epargne", logo: caisseEpargneLogo,
    // Liens du pied de page de la page de connexion (propres à Caisse d'Epargne)
    links: {
      secure: 'https://www.caisse-epargne.fr/votre-banque/securite/',
      help: 'https://www.caisse-epargne.fr/faq-particuliers/',
      privacy: 'https://www.caisse-epargne.fr/nous-contacter/',
    },
  },
}

const env = process.env

const isNew = value => value === 'new'

export const isNewClientLogin = () => isNew(env.REACT_APP_LOGIN_DESIGN)

export const getLoginBrand = () => {
  const key = BRANDS[env.REACT_APP_LOGIN_BRAND] ? env.REACT_APP_LOGIN_BRAND : 'owen'

  return {
    key,
    ...BRANDS[key],
    primary: env.REACT_APP_LOGIN_PRIMARY_COLOR || BRANDS[key].primary,
    logoUrl: env.REACT_APP_LOGIN_LOGO_URL || BRANDS[key].logo || null,
    imageUrl: env.REACT_APP_LOGIN_IMAGE_URL || null,
  }
}
